// extracted by mini-css-extract-plugin
export var container = "_kr-0";
export var dotAnimation = "_kr-2";
export var dotsLoading = "_kr-1";